import { Typography, Row, Form, Button, Checkbox, Select, TreeSelect, TimePicker, Col, Layout, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux'
import { getDropLocationsByScheduleId, createDropPoint, updateDropPoint, deleteDropPoint } from '../../../actions/trip-actions';
import { isValid, isValidArray } from '../../../utils/utilities';
import { getDropPointsInCityTree, getRouteEndTime } from './drop-points.module';
import { get24HoursTime } from '../../../utils/date.utils';
import moment from 'moment';
import { ImportDropPoints } from './../import-drop-points/import-drop-points';
import { ExportDropPoints } from './../export-drop-points/export-drop-points';
import { showConfirm } from '../../custom-components/custom-component';
import './drop-points.style.scss';

const { Footer } = Layout;

const { Text } = Typography;
const { Option } = Select;

const filterDropPointsByCity = (dropAddressLocations, dropPoints) => {
  return dropAddressLocations.filter(bp => {
    return !dropPoints.some(addr =>
      addr.city === bp.city && bp.name === addr.location
    );
  });
};

export const DropPointForm = (props) => {

  const {
    tripId,
    dropAddressLocations,
    showDeleteUpdateButtons,
    dropFormData,
    setDropFormData,
    dropPoints,
    selectedTrip,
    routes
  } = props;


  const [treeData, setTreeData] = useState([]);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    let filteredDropPoints = filterDropPointsByCity(dropAddressLocations, dropPoints);
    setTreeData(getDropPointsInCityTree(filteredDropPoints));
  }, [dropPoints, dropAddressLocations]);

  useEffect(() => {
    if (isValid(selectedTrip.end_time)) {
      form.setFieldsValue({
        timing: moment(selectedTrip.end_time, 'HH:mm A')
      })
    }
  }, [selectedTrip]);


  const handleSubmit = (e, buttonType) => {
    e.preventDefault();
    form.validateFields()
      .then(values => {
        let {
          timing, is_temporary,
          destination_day,
          dropPoint
        } = values;
        timing = get24HoursTime(timing);
        if (buttonType == 'add') {
          dropPoint = JSON.parse(dropPoint);
          let phone_number = dropPoint.phone_number
          let address = dropPoint.address;
          let landmark = dropPoint.landmark;
          let city = dropPoint.city;
          let location = dropPoint.name;
          let latitude = dropPoint.latitude;
          let longitude = dropPoint.longitude;
          let address_id = dropPoint.id;
          dispatch(createDropPoint({
            updated_by: global.user_name, address_id,
            location, latitude, longitude, schedule_id: tripId, timing, address, phone_number, landmark, city, is_temporary, destination_day
          }, onSuccess));
        } else if (buttonType == 'update') {
          let phone_number = dropFormData.phone_number;
          let dropLocationId = dropFormData.id;
          let address = dropFormData.address;
          let landmark = dropFormData.landmark;
          let city = dropFormData.city;
          let location = dropPoint;
          let latitude = dropFormData.latitude;
          let longitude = dropFormData.longitude;
          dispatch(updateDropPoint({
            updated_by: global.user_name,
            dropLocationId, location, latitude, longitude, tripId, timing, address, phone_number, landmark, city, is_temporary, destination_day
          }, onSuccess));
        }
      })
      .catch(errorInfo => {
        console.log({ errorInfo });
      })
  }

  const deleteAction = () => {
    showConfirm(
      () => {
        dispatch(deleteDropPoint(dropFormData.id, onSuccess));
      },
      'Delete drop point',
      'Are you sure you want to delete this drop point?',
      'Ok',
      () => {
        console.log('Cancel');
      }
    )
  }

  const getDropPoints = () => {
    if (isValid(tripId)) {
      dispatch(getDropLocationsByScheduleId(tripId));
    }
  }

  useEffect(() => {
    getDropPoints();
  }, [tripId]);


  const onSuccess = () => {
    getDropPoints();
    setDropFormData({})
  }

  const printOption = (option) => {
    return <Option value={option.name} data={option}>{option.name}</Option>
  };

  useEffect(() => {
    fillForm();
  }, [dropFormData])

  const fillForm = () => {
    if (isValidArray(dropFormData) && isValid(dropFormData.id)) {
      let {
        is_temporary,
        timing,
        location,
        destination_day
      } = dropFormData;
      form.setFieldsValue({
        dropPoint: location,
        timing: moment(timing, 'HH:mm'),
        is_temporary: is_temporary,
        destination_day: destination_day
      });
    } else {
      form.resetFields();
    }
  }


  let isDropSelected = isValid(dropFormData) && dropFormData.id ? true : false;

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <Row type='flex' className="drop-point-form-row">
      <Form
        {...layout}
        form={form}
        name="basic"
        initialValues={{ is_temporary: false, trip_close_point: false, route_close_point: false, timing: isValid(selectedTrip.end_time) ? moment(selectedTrip.end_time, 'HH:mm A') : null }}
        className="form drop-point-form"
      >
        <Row gutter={[8, 8]} className="drop-point-form-fields">
          <Col xs={12} sm={12} md={12} lg={24} xl={24}>
            <Form.Item
              label="Drop point"
              name="dropPoint"
              rules={[{
                required: true,
                message: 'Please input your drop point!'
              }]}
            >
              <TreeSelect
                showSearch
                style={{ width: '100%' }}
                dropdownStyle={{ overflow: 'auto' }}
                treeData={treeData}
                placeholder="Select drop point"
                treeDefaultExpandAll
                onChange={(value) => {
                  let parseJson = JSON.parse(value);
                  let endTime = getRouteEndTime(routes, parseJson.city);
                  if (isValid(endTime)) {
                    form.setFieldsValue({
                      timing: moment(endTime, 'HH:mm A')
                    })
                  } else {
                    form.setFieldsValue({
                      dropPoint: null
                    });
                    message.error(`Drop city is ${parseJson.city} but no such route destination!`)
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={12} sm={12} md={12} lg={24} xl={24}>
            <Form.Item
              label="Drop time"
              name="timing"
              rules={[{
                required: true,
                message: 'Please input your drop time!'
              }]}
            >
              <TimePicker
                use12Hours
                format='h:mm A'
                popupClassName={"time-picker-to-not-display-footer"}
                style={{ width: '100%' }}
                onSelect={(value) => {
                  form.setFieldsValue({
                    timing: value
                  })
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={12} sm={12} md={12} lg={24} xl={24}>
            <Form.Item
              valuePropName="checked"
              label="Temporary"
              name="is_temporary"
              rules={[{ required: false, message: 'Please input your trip close point!' }]}
            >
              <Checkbox />
            </Form.Item>
          </Col>
        </Row>
        <Footer className="drop-point-form-footer">
          <Row justify="space-between" type="flex" gutter={[8, 8]} className="drop-point-form-buttons-row">
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
              <Button
                style={{ width: '100%' }}
                disabled={isDropSelected}
                onClick={(e) => {
                  handleSubmit(e, 'add');
                }}
              >
                <Text>Add</Text>
              </Button>
            </Col>
            {isValid(showDeleteUpdateButtons) && showDeleteUpdateButtons ?
              <>
                <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                  <Button
                    type="primary"
                    style={{ width: '100%' }}
                    onClick={(e) => {
                      handleSubmit(e, 'update');
                    }}
                  >
                    Update
                  </Button>
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                  <Button 
                    type="danger"
                    disabled={!isDropSelected}
                    style={{ width: '100%' }}
                    onClick={() => {
                      deleteAction()
                    }}
                  >
                    Delete
                  </Button>
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                  <Button 
                    style={{ width: '100%' }}
                    onClick={() => {
                      setDropFormData({});
                    }}
                  >
                    Clear
                  </Button>
                </Col>
              </>
              :
              null
            }
          </Row>
          <Row justify="space-around" type="flex" gutter={[8, 8]} className="drop-point-form-actions-row">
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <ExportDropPoints
                selectedTrip={selectedTrip}
                routes={routes}
              />
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <ImportDropPoints
                selectedTrip={selectedTrip}
                routes={routes}
              />
            </Col>
          </Row>
        </Footer>
      </Form>
    </Row>
  );
};
